import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import SmoothScroll from './SmoothScroll'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
    <SmoothScroll />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
